module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0014.jpg?v=5c00f693";